import React from 'react';
import { Link } from 'react-router-dom';

import { PageRoutes } from '../enums/enums';
import { type GhostPostSummaryItemModel } from '../models/GhostPostSummaryListModel';
import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';
import ImageWrapper from './ImageWrapper';

interface Props {
  post: GhostPostSummaryItemModel;
  width: number;
}

export default function MagicCarouselArticleCard(props: Props) {
  const readMoreLabel = CLocalizedTextStringStatic('globalReadMore');

  const formattedExcerpt = (excerpt: string) => {
    const excerptMinusOneToken = excerpt.split(' ').slice(0, -1);

    return (
      <>
        {excerptMinusOneToken.length > 0 && <span>{[...excerptMinusOneToken].join(' ')}...&nbsp;</span>}
        <a>{readMoreLabel}</a>
      </>
    );
  };

  return (
    <Link
      to={`../../${PageRoutes.NEWS_OUTLET}/${PageRoutes.NEWS_ARTICLES_OUTLET}/${props.post.slug}`}
      className={'text-slate-800 hover:text-teal'}
    >
      <div
        className={'aspect-video rounded-xl relative overflow-hidden font-normal'}
        style={{ width: 0.9 * props.width }}
      >
        <ImageWrapper alt={props.post.title ?? ''} src={props.post.featureImage} className={'w-full h-full'} />
      </div>
      <div className={'font-normal p-4 flex flex-col gap-4'}>
        <h3 className={'text-3xl'}>{props.post.title}</h3>
        <p>{formattedExcerpt(props.post.excerpt ?? '')}</p>
      </div>
    </Link>
  );
}
